"use client";

import i18next, { createInstance } from "i18next";
import { createContext, useMemo } from "react";
import { I18nextProvider } from "react-i18next";
import type { ReactNode } from "react";

type AppRouterI18nContextType = {
  translations: Record<string, string>;
  ns: string;
  locale: string;
};

export const AppRouterI18nContext = createContext<AppRouterI18nContextType | null>(null);

export function AppRouterI18nProvider({
  children,
  translations,
  locale,
  ns,
}: AppRouterI18nContextType & {
  children: ReactNode;
}) {
  const i18n = useMemo(() => {
    const instance = createInstance();
    instance.init({
      lng: locale,
      resources: {
        [locale]: {
          [ns]: translations,
        },
      },
      interpolation: { escapeValue: false },
      fallbackLng: i18next.options?.lng || "en",
    });
    return instance;
  }, [locale, ns, translations]);

  return (
    <AppRouterI18nContext.Provider value={{ translations, locale, ns }}>
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </AppRouterI18nContext.Provider>
  );
}
